module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/contents.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptert"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("1 Idiots Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("2 Communist Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Someday you will Be Loved")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Wake Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Only Shallow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 How High the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 I Just Wanna Get Along")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Monkey Gone to Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Caring Is Creepy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Heaven’t Got a Clue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Yerself Is Steam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Taste the Pain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Addicted to Fame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Everything in Its Right Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Sins of the Father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 I Hate Rock ’n’ Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The Moon and Antarctica")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 So Far I Have Not Found a Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/sammysrock#sam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sammy’s Rock and Jazz Mashup Playlist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0